<p-toast key="incoming-call" position="top-right" styleClass="incoming-call-toast">
  <ng-template let-message #message>
    <div class="toast-incoming" (click)="$event.stopPropagation()">
      <div class="toast-incoming-info">
        <div class="toast-incoming-header">
          <div class="toast-incoming-dot"></div>
          <span class="toast-incoming-label">{{
            callerSummary() ?? message.summary
          }}</span>
          @if (badgeQueueName(); as badge) {
            <span class="toast-incoming-queue" [attr.title]="badge">{{ badge }}</span>
          }
        </div>
        @if (transferFromAgentName()) {
          <div class="toast-incoming-transfer-from">
            <i class="pi pi-arrow-right-arrow-left" aria-hidden="true"></i>
            <span>{{
              'AgentDesktop::Telephony:TransferredFrom'
                | abpLocalization: (transferFromAgentName() ?? '')
            }}</span>
            @if (originQueueName(); as origin) {
              <span
                class="toast-incoming-origin-queue"
                [attr.title]="'AgentDesktop::Telephony:TransferredFromQueue' | abpLocalization: origin"
                >{{ origin }}</span
              >
            }
          </div>
        }
        @if (callerName()) {
          <div class="toast-incoming-name">{{ callerName() }}</div>
        }
        <div class="toast-incoming-detail">{{ callerDetail() ?? message.detail }}</div>
      </div>
      <div class="toast-incoming-actions">
        <button
          type="button"
          class="toast-action-btn toast-mute-btn"
          [class.toast-muted]="ringtoneMuted()"
          [attr.aria-label]="
            (ringtoneMuted()
              ? 'AgentDesktop::Telephony:Unmute'
              : 'AgentDesktop::Telephony:Mute'
            ) | abpLocalization
          "
          [attr.title]="
            (ringtoneMuted()
              ? 'AgentDesktop::Telephony:Unmute'
              : 'AgentDesktop::Telephony:Mute'
            ) | abpLocalization
          "
          (click)="onMuteToggle()"
        >
          <i class="pi pi-volume-up" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="toast-action-btn ad-call-action-accept toast-answer-btn"
          [class.toast-answering]="toastAnswering()"
          [class.ad-call-action-active]="toastAnswering()"
          [disabled]="toastAnswering()"
          (click)="onAnswer()"
        >
          <i class="pi pi-phone" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="toast-action-btn ad-call-action-decline toast-reject-btn"
          [disabled]="toastAnswering()"
          (click)="onReject()"
        >
          <i class="pi pi-phone"></i>
        </button>
      </div>
    </div>
  </ng-template>
</p-toast>
